export default "__VITE_ASSET__a629ca5f__"